import colors from 'vuetify/lib/util/colors';

const all = Object.keys(colors);
const shades = Object.keys(colors.blue);
const map = {
  checkbox: colors.deepPurple.base,
  clear: colors.deepPurple.lighten5,
  click: colors.blue.base,
  clickByPartialText: colors.blue.lighten2,
  clickByText: colors.blue.lighten1,
  confirmPrompt: colors.orange.base,
  csvParse: colors.deepOrange.base,
  csvWrite: colors.deepOrange.lighten1,
  dismissAlert: colors.orange.lighten2,
  downloadFile: colors.purple.darken2,
  downloadFileBrowser: colors.purple,
  dragAndDrop: colors.pink.darken2,
  dragAndDropFile: colors.pink.darken4,
  elementContains: colors.teal.base,
  enter: colors.cyan.darken1,
  fileExists: colors.deepPurple.lighten2,
  freshTab: colors.amber.darken2,
  get: colors.indigo.base,
  getActions: colors.grey.base,
  getChildElement: colors.lightBlue.lighten1,
  getChildElementByPartialText: colors.lightBlue.lighten2,
  getChildElementByText: colors.lightBlue.lighten3,
  getClipboardContent: colors.brown.lighten2,
  getCurrentUrl: colors.blueGrey.base,
  getElement: colors.lightBlue.darken2,
  getElementEvenIfNotVisible: colors.lightBlue.darken3,
  getElementByPartialText: colors.lightBlue.lighten2,
  getElementByText: colors.lightBlue.lighten3,
  getElements: colors.lightBlue.darken1,
  getEnabledElement: colors.lightBlue.darken3,
  getEnabledElementByText: colors.lightBlue.darken2,
  getHtml: colors.blueGrey.lighten2,
  getParentElement: colors.blue.darken1,
  getParent: colors.blue.darken2,
  getPdfText: colors.red.lighten1,
  getPdfTextFile: colors.red.lighten2,
  getSimpleUrlDate: colors.blueGrey.lighten3,
  guid: colors.blueGrey.darken1,
  highlightLine: colors.yellow.base,
  highlightLines: colors.yellow.lighten1,
  hover: colors.blue.lighten3,
  inputFile: colors.deepPurple.base,
  inputLocalFile: colors.deepPurple.base,
  isodate: colors.blueGrey.lighten4,
  pageContains: colors.green.darken2,
  randomNumber: colors.blueGrey.darken1,
  readFile: colors.deepPurple.lighten1,
  refresh: colors.indigo.lighten1,
  salt: colors.grey.base,
  sandbox: colors.grey.base,
  scopedClick: colors.blue.darken1,
  scopedClickByPartialText: colors.blue.darken2,
  scopedClickByText: colors.blue.darken3,
  scopedType: colors.cyan.darken2,
  scrollTo: colors.brown.lighten1,
  setClipboardContent: colors.brown.base,
  sleep: colors.blueGrey.lighten2,
  switchToPopup: colors.lime.base,
  switchToWindow: colors.lime.darken1,
  type: colors.cyan.base,
  urlContains: colors.grey.darken2,
  waitUntilGone: colors.grey.base,
  waitForWindow: colors.grey.base,
  year: colors.grey.base,
  startUp: colors.blueGrey.lighten1,
  gap: colors.blueGrey.lighten3
};

const Color = {
  getRandomColor() {
    const color = all[Math.floor(Math.random() * all.length)];
    const shade = shades[Math.floor(Math.random() * shades.length)];
    return colors[color][shade];
  },
  getColorForMacro(macro) {
    if (macro in map) return map[macro];
    return this.getRandomColor();
  }
};

export default Color;
